import { Controller } from '@hotwired/stimulus'

// Scales an iframe rendering of a SiteTemplate preview to fit a thumbnail
// container. The iframe is laid out at a fixed natural width (a desktop
// viewport) and then `transform: scale()` shrinks it down. We update the
// scale on connect + on container resize so it stays correct across the
// 1/2/3-column responsive grid.
//
// Usage:
//   <div data-controller="admin--site-template-thumb"
//        data-admin--site-template-thumb-natural-width-value="1440">
//     <iframe ...></iframe>
//   </div>
export default class extends Controller {
  static values = {
    naturalWidth: { type: Number, default: 1440 }
  }

  connect() {
    this.update = this.update.bind(this)
    this.update()
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(this.update)
      this.observer.observe(this.element)
    } else {
      window.addEventListener('resize', this.update)
    }
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener('resize', this.update)
  }

  update() {
    const width = this.element.clientWidth
    if (!width) return
    const scale = width / this.naturalWidthValue
    this.element.style.setProperty('--thumb-scale', scale.toString())
  }
}
